<template>
    <!-- Begin Pricing Area -->
    <div id="testimonial" class="testimonial-area testimonial-style-3" data-bg-image="" :style="{backgroundImage: `url(${ mainBg })`}">
        <div id="pricing-container" class="container">
            <div class="section-area">
                <h2 class="section-title">Hinnasto</h2>
                <p class="section-desc">Kaikki hinnat alv. 0 %</p>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="pricing-tab-content" style="margin-bottom: 10rem;">
                        <div class="pricing-item-wrap row mt-n30">
                            <component :is="showWhich"></component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Pricing Area End Here -->
</template>
<script>
import MonthlyTwo from '@/pricing/MonthlyTwo.vue'
import YearlyTwo from '@/pricing/YearlyTwo.vue'

export default {
  components: {
    MonthlyTwo,
    YearlyTwo
  },
  data () {
    return {
    mainBg: 'images/testimonial/bg/3-1-1920x913.png',
      showWhich: 'YearlyTwo'
    }
  }
}
</script>
